module.exports = __webpack_public_path__ + "img/new.1e699f56.svg";